/* ==========================================================================
   Weespice shared product card behaviour.

   One delegated listener on the document handles every [data-ws-atc] button
   on the page, so this works for any number of sections, and for cards that
   are injected later (theme editor re-renders, AJAX filtering).
   ========================================================================== */
(function () {
  if (window.wsProductCardReady) return;
  window.wsProductCardReady = true;

  var ADDED_RESET_MS = 2000;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /**
   * Writes the count into the theme's cart icon and any legacy badges.
   * Safe to run alongside the standard cart event: both set the same number.
   */
  /**
   * Writes the count into the theme's cart icon and any legacy badges.
   * Safe to run alongside the standard cart event: both set the same number.
   */
  function applyCartCount(cart) {
    /* The theme's cart icon owns the count, the hidden state, the bump
       animation and the sessionStorage mirror it uses to correct itself on
       bfcache restore, so drive it rather than patching its DOM. Falls back
       to writing the refs directly if the element has not upgraded yet. */
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(cart.item_count);
        return;
      }

      var count = icon.querySelector('[ref="cartBubbleCount"]');
      var bubble = icon.querySelector('[ref="cartBubble"]');

      if (count) {
        count.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
        count.classList.toggle('hidden', cart.item_count === 0);
      }
      if (bubble) bubble.classList.toggle('visually-hidden', cart.item_count === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', cart.item_count > 0);
    });

    /* Badges from the previous custom header, kept for any page still
       rendering them. */
    var desktopBadge = document.getElementById('wsCartCount');
    if (desktopBadge) desktopBadge.textContent = cart.item_count;

    document
      .querySelectorAll(
        '.ws-mob-cart-badge, .ws-mob-cart-badge-count, .cart-count-bubble, .cart-count, [data-cart-count]'
      )
      .forEach(function (el) {
        el.textContent = cart.item_count;
      });

    /* Legacy hook from the old custom header. Not defined anywhere in this
       theme, so normally a no-op. */
    if (typeof window.openWsCartDrawer === 'function') window.openWsCartDrawer();
  }

  function announceCartUpdate(cart, sections) {
    var payload = {
      cart: { totalQuantity: cart.item_count },
      detail: { itemCount: cart.item_count, sections: sections || {} }
    };

    var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true, composed: true });
    event.action = 'add';
    event.promise = Promise.resolve(payload);

    var target = document.querySelector('theme-drawer#cart-drawer') || document;
    target.dispatchEvent(event);
  }

  /**
   * Quantity for this add. Cards never pass one and stay at 1; the product
   * page points data-ws-qty-input at its stepper so the chosen number is
   * used. Read at click time rather than cached, since the stepper can change
   * between renders.
   */
  function quantityFor(button) {
    var inputId = button.getAttribute('data-ws-qty-input');
    if (!inputId) return 1;

    var input = document.getElementById(inputId);
    if (!input) return 1;

    var value = parseInt(input.value, 10);
    return value > 0 ? value : 1;
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = button.querySelector('[data-ws-atc-label]');
    var originalText = label ? label.textContent.trim() : 'ADD TO CART';

    button.disabled = true;
    if (label) label.textContent = 'ADDING...';

    /* Add through the Ajax Cart API. This is the endpoint Shopify's web
       pixels instrument, so product_added_to_cart fires from it; the earlier
       Shopify.actions.updateCart path opened the drawer but stopped the
       tracking that the previous custom-liquid code had.

       `sections` asks Shopify to return the cart drawer's rendered HTML in
       the same response, which is what the theme needs to refresh the drawer
       without a second request. */
    var cartItems = document.querySelector('.cart-items-component[data-section-id]');
    var cartSectionId = cartItems ? cartItems.getAttribute('data-section-id') : null;

    var body = { id: parseInt(variantId, 10), quantity: quantityFor(button) };
    if (cartSectionId) body.sections = cartSectionId;

    var request = fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function (added) {
        return fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            announceCartUpdate(cart, added.sections);
            /* Belt and braces: if nothing consumed the event, the count is
               still correct. Both paths write the same number. */
            applyCartCount(cart);
            return cart;
          });
      });

    request
      .then(function () {
        button.classList.add('ws-card-atc--success');
        if (label) label.textContent = '✓ ADDED!';
      })
      .then(function () {
        window.setTimeout(function () {
          button.classList.remove('ws-card-atc--success');
          if (label) label.textContent = originalText;
          button.disabled = false;
        }, ADDED_RESET_MS);
      })
      .catch(function (error) {
        console.error('[ws-product-card] add to cart failed:', error);
        if (label) label.textContent = 'RETRY';
        button.disabled = false;
        window.setTimeout(function () {
          if (label) label.textContent = originalText;
        }, ADDED_RESET_MS);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ws-atc]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(button);
  });
})();
